exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nhr[data-v-006a876f] {\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n.input-group-text[data-v-006a876f] {\n  font-size: small;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-006a876f","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/reglesEcheancier/SettingsEcheancierRegles.vue
// module id = 1089
// module chunks = 2